import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import { forwardRef } from 'react';
import '@wcj/dark-mode';
import { styled } from 'styled-components';
import GitHubCorners from '@uiw/react-github-corners';
import BackToUp from '@uiw/react-back-to-top';
import { Github } from './Github';
import { Corners } from './Corners';
import { Example } from './Example';
import { useStores } from './store';
import Markdown from './Markdown';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ExampleWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  max-width: 56rem;\n  margin: 0 auto;\n  padding: 2.3rem 3rem;\n"])));
var Wrappper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  padding-bottom: 9rem;\n"])));
var Header = styled.header(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  padding: 6rem 0 2rem 0;\n  text-align: center;\n  h1 {\n    font-weight: 900;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif,\n      'Apple Color Emoji', 'Segoe UI Emoji';\n  }\n"])));
var SupVersion = styled.sup(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  font-weight: 200;\n  font-size: 0.78rem;\n  margin-left: 0.5em;\n  margin-top: -0.3em;\n  position: absolute;\n"])));
var InternalMarkdownPreviewExample = /*#__PURE__*/forwardRef((props, ref) => {
  var {
    version,
    title,
    source,
    components,
    data,
    markdownProps,
    children,
    disableCorners = false,
    disableDarkMode = false,
    disableHeader = false,
    disableBackToUp = false
  } = props;
  var store = useStores();
  return /*#__PURE__*/_jsxs(Wrappper, {
    children: [!disableDarkMode && /*#__PURE__*/_jsx("dark-mode", _extends({
      permanent: true,
      style: {
        position: 'fixed',
        top: 8,
        left: 12,
        zIndex: 99,
        fontSize: 28
      }
    }, store.darkMode)), !disableCorners && /*#__PURE__*/_jsx(GitHubCorners, _extends({
      fixed: true,
      target: "__blank",
      zIndex: 10
    }, store.corners)), !disableHeader && /*#__PURE__*/_jsx(Header, {
      children: title && /*#__PURE__*/_jsxs("h1", {
        children: [title, version && /*#__PURE__*/_jsx(SupVersion, {
          children: version
        })]
      })
    }), store.example && /*#__PURE__*/_jsx(ExampleWrapper, {
      children: store.example
    }), /*#__PURE__*/_jsx(Markdown, _extends({}, markdownProps, {
      source: source,
      components: components,
      data: data
    })), children, !disableBackToUp && /*#__PURE__*/_jsx(BackToUp, {
      children: "Top"
    })]
  });
});
var MarkdownPreviewExample = InternalMarkdownPreviewExample;
MarkdownPreviewExample.Github = Github;
MarkdownPreviewExample.Corners = Corners;
MarkdownPreviewExample.Example = Example;
export default MarkdownPreviewExample;